'use strict';

intellidealerAppCoreModule.factory('partRemanufacturedResource', function ($resource, appConfigurationService) {
  return {
    myDealerCustomerPartRemanufacturedByPartAndLocation: $resource(appConfigurationService.basePath + '/rest/partremanufactured/myDealerCustomerPartRemanufacturedByPartAndLocation/')
  }
});
